import { Grid, Typography } from '@mui/material';
import { WithStyles, withStyles } from '@mui/styles';
import { BasicButton } from '@tassat/button';
import { ClientMessagesStatusEnum } from '@tassat/common-definitions';
import { browserSessionStore } from '@tassat/utility';
import React from 'react';
import MarkdownView from 'react-showdown';

import { JS_TIMER_MAX } from 'Lib/constant';
import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';
import { useAppSelector } from 'Reducers/store/hooks';
import { getClientAdvisoryMessage } from 'Selectors/clientMessages';

interface IAdvisoryMessage extends WithStyles<typeof muiStyles> {
    className?: string;
}

const muiStyles = (theme: ApplicationMuiTheme) => ({
    advisoryBack: {
        height: '100vh',
        width: '100vw',
        position: 'fixed' as 'fixed',
        zIndex: 1000000,
        backgroundColor: theme?.app?.applicationColors.enumColors.offWhite ||
            '#F3F3F3',
        top: '0',
        left: '0'
    },
    advisoryCard: {
        background: theme?.app?.applicationColors.enumColors.white ||
            '#FFFFFF',
        padding: '45px 20px',
        position: 'absolute' as const,
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        width: '600px',
        zIndex: 9000000,
        borderTop: `10px solid ${theme?.app?.clientTheme.colors.primaryColorLight ||
        '#009BDF'}`
    },
    akButton: {
        margin: '25px',
        borderRadius: '25px'
    },
    banner: {
        fontSize: '18px',
        lineHeight: '25px'
    },
    bannerHtml: { '& > *': { margin: '0px' }}
});

export function AdvisoryMessageComponent(props: IAdvisoryMessage) {
    const { classes } = props;

    const advisory = useAppSelector(getClientAdvisoryMessage);

    const [ showAdvisdory, setShowAdvisdory ] = React.useState<boolean>(false);

    React.useEffect(() => {
        if (advisory.MessageId == browserSessionStore.getItem('advisoryAck')) {
            return;
        }

        const remainingTime = advisory?.EndAt ? (Number(advisory?.EndAt) - Date.now()) : 0;

        if (remainingTime > 100) {
            setShowAdvisdory(true);

            // If remaining time is too large for a timer, then don't worry about it as it will be multiple days
            if (remainingTime < JS_TIMER_MAX) {
                setTimeout(() => {
                    setShowAdvisdory(false);
                    browserSessionStore.removeItem('advisoryAck');
                }, remainingTime - 100);
            }
        }
    }, [advisory]);

    const acknowledgeAdvisory = () => {
        browserSessionStore.setItem('advisoryAck', advisory.MessageId);
        setShowAdvisdory(false);
    };

    return (
        <>
            {
                showAdvisdory && advisory.Status == ClientMessagesStatusEnum.DISPLAYABLE ?
                    <Grid
                        className={classes.advisoryBack}
                        container
                        direction='column'
                        item
                    >
                        <Grid
                            className={classes.advisoryCard}
                            container
                            direction='row'
                            item
                        >

                            <Grid
                                alignItems='center'
                                container
                                direction='column'
                                item
                            >
                                <Typography
                                    className={classes.banner}
                                    variant='body1'
                                ><strong>IMPORTANT MESSAGE</strong>
                                </Typography>
                                <div className={classes.bannerHtml} >
                                    <MarkdownView markdown={advisory?.Message} />
                                </div>
                                <BasicButton
                                    className={classes.akButton}
                                    onClick={acknowledgeAdvisory}
                                    text='ACKNOWLEDGED'
                                    type='main'
                                />
                            </Grid>
                        </Grid>

                    </Grid>
                    : null
            }
        </>
    );
}

const AdvisoryMessage = withStyles(muiStyles)(AdvisoryMessageComponent);
export { AdvisoryMessage };